const REDIRECT_KEY = 'redirectAfterLogin';

export const saveRedirectPath = (path) => {
  if (path && path !== '/') {
    localStorage.setItem(REDIRECT_KEY, path);
  }
};

export const popRedirectPath = () => {
  const path = localStorage.getItem(REDIRECT_KEY);
  localStorage.removeItem(REDIRECT_KEY);
  return path;
};
